import type { IAccountNotification } from "@apis/accounts/types"
import { AccountNotificationItem } from "./AccountNotificationItem"

type TAccountEventListProps = {
  account_id: string
  prospect_guid: string
  account_notifications: IAccountNotification[]
}

export const AccountNotificationList = ({
  account_id,
  prospect_guid,
  account_notifications,
}: TAccountEventListProps) => {
  if (!account_notifications.length) {
    return (
      <div className="tw:p-4 tw:text-center tw:text-gray-500">
        No events to display
      </div>
    )
  }
  return (
    <>
      {account_notifications.map((notification, i) => (
        <AccountNotificationItem
          key={`${notification.type}-${notification.date}-${i}`}
          account_id={account_id}
          prospect_guid={prospect_guid}
          notification={notification}
        />
      ))}
    </>
  )
}
